import { Unit } from "./Unit";
import { UnitGroup } from "./UnitGroup";

export class LengthUnits extends UnitGroup {
    private static _singleton: LengthUnits;

    public static readonly FOOT = new Unit("FT", "Feet");
    public static readonly INCH = new Unit("IN", "Inch");
    public static readonly METER = new Unit("M", "Meters");
    
    constructor() {
        const units = [ LengthUnits.FOOT, LengthUnits.INCH, LengthUnits.METER ];
        super(units, "length_company_um", "length_functional_um");
    }

    public static get singleton(): LengthUnits {
        if (this._singleton == null) {
            this._singleton = new LengthUnits();
        }
        return this._singleton;
    }
}
